<template>
    <div class="page-content" id="device-list">
        <Titlebar :incrustation="'fa-exclamation-triangle'">
            <h1>{{ $t('device.notifications.titles.list') }}</h1>
        </Titlebar>
        <div class="fake-tabs" role="tab">
            <div @click="setStatusFilter(false)" :class="{active:statusFilter === false}">{{ $t('device.notifications.filters.all') }}</div>
            <div @click="setStatusFilter('planified')" :class="{active:statusFilter === 'planified'}">{{ $t('device.notifications.filters.scheduled') }}</div>
            <div @click="setStatusFilter('sent')" :class="{active:statusFilter === 'sent'}">{{ $t('device.notifications.filters.sent') }}</div>
        </div>
 
        <UiCard >
            <div >
                <div style="display: flex; margin-bottom: 10px; align-items: center">
                    <label>
                        <input type="checkbox" v-model="activeNotificationFilter" true-value="1" false-value="0">
                        {{ $t('device.notifications.btns.hideReminders') }}
                    </label>
                </div>
            </div>

            <SuperTable
                class="notification-table"
                ref="tableNotifications"
                :tableColumns="tableColumns"
                :tableData="tableData"
                @sort="handleSort"
                @filter="handleFilter"
                @delete="handleDelete"
                :loading="isLoading"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn :class="'default'">
                        <router-link to="/parameters/notifications/new" tag="span"><i class="fa fa-plus"></i><span>{{ $t('device.notifications.btns.new') }}</span>
                        </router-link>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Globals from '@/services/globals.js';
    import Auth from '@/services/auth.js'
    import Utils from '@/services/utils.js'
    import moment from 'moment';
    import 'moment-timezone';

    import { Can } from '@/directives/Can.js';

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";

    import PhoneLabelRenderer from "@/components/devices/tableRenderers/DeviceRenderer";
    import ProfileRenderer from "@/components/devices/tableRenderers/ProfileRenderer";
    import UserRenderer from "@/components/ui/TableRowUserRenderer";

    import Association from '@/views/devices/Association';
    import {useDvFlagAccess} from "../../../services/featureFlag";

    export default {
        name: 'NotificationsList',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            Pagination,
            SuperTable,
            Association
        },
        computed: {
        },
        data(){
            return {
                isLoading: true,
                count: 0,
                config: {
                    perpage: Globals.perPage,
                    fields: [],
                    page: 1,
                    filter: {
                        like: this.activeNotificationFilter ? ['type:notification'] : [],
                        equals: []
                    },
                    sort: ['-sending_date']
                },
                activeNotificationFilter: 0,
                statusFilter: false,
                tableColumns: {
                    global: {
                        sortable: false,
                        noItemsMsg: window.V.$i18n.t('device.notifications.emptyTable')
                    },
                    columns: [
                        {
                            key: 'title',
                            label: Utils.t('device.notifications.title'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: true,
                            filter: {
                                type: 'text'
                            },
                            //renderer: PhoneLabelRenderer,
                            width: '20%'
                        },
                        {
                            key: 'content',
                            label: Utils.t('device.notifications.content'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: true,
                            filter: {
                                type: 'text',
                            },
                            width: '50%'
                        },
                        {
                        key: 'type',
                        label: 'Type',
                        showPopup: false,
                        activeFilter: '',
                        activeSort: false,
                        sortable: true,
                        filter: {
                            type: 'text',
                        },
                        width: '7%'
                        },
                        {
                            key: 'theoric_sending_date',
                            label: Utils.t('device.notifications.theoricSendingDate'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: true,
                            filter: false,
                            width: '10%',
                            renderer: function(item){
                                if(item.theoric_sending_date && !item.sending_date) {
                                    return moment.tz(item.theoric_sending_date.date, item.theoric_sending_date.timezone).local().format('DD/MM/YYYY HH:mm')
                                }
                                return ''
                            }
                        },
                        {
                            key: 'sending_date',
                            label: Utils.t('device.notifications.sendingDate'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: true,
                            filter: false,
                            width: '10%',
                            renderer: function(item){
                                if(item.sending_date) {
                                    return moment.tz(item.sending_date.date, item.sending_date.timezone).local().format('DD/MM/YYYY HH:mm')
                                }
                                return ''
                            }
                        },
                        {
                            key: 'sender',
                            label: Utils.t('device.notifications.sender'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: true,
                            filter: false,
                            width: '10%'
                        },
                        {
                            key: 'nb_datis',
                            label: Utils.t('device.notifications.datis'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: true,
                            filter: false,
                            width: '10%',
                            className: 'bold text-right',
                        },
                    ],
                    rowActions: {
                        width: '10%',
                        actions: []
                    }
                },
                manufacturerFilter: [],
                modelFilter: [],
                tableData: [],
                profiles: [],
                groups: []
            }
        },
        methods: {
            loadData: function () {
              this.isLoading = true;
              let speFilter = ''
              if(this.statusFilter){
                speFilter = '&filter='+this.statusFilter
              }
              axios.get(API.endpoints.datis.notifications + API.constructQueryParams(this.config) + speFilter)
                .then(response => {
                  this.tableData = response.data.data;
                  this.count = response.data.meta.pagination.total;
                  this.$refs.pagination.update(response.data.meta.pagination);
                  window.Vfc.$refs.loading.hide();
                  this.isLoading = false;
                })
            },
            switchFilterStatus: function() {
              window.V.$localStorage.set('BPZ_NOTIFICATION_FILTER', this.activeNotificationFilter)
              this.config.filter.like = this.activeNotificationFilter == 1 ? ['type:notification'] : []
              this.loadData()
            },
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.page = 1;
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter != '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            setStatusFilter(val){
                // window.Vfc.$refs.loading.show();
                this.isLoading = true;
                this.statusFilter = val
                this.loadData()
            },

            handleDelete: function(item){
                var vThis = this;
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: function () {
                        axios.delete(API.route(API.endpoints.datis.notificationsItem, {id: item.id}))
                            .then(response => {
                                if(vThis.tableData.length == 1 && vThis.config.page > 1){
                                    vThis.config.page--;
                                }
                                vThis.loadData();
                            })
                            .catch(error => {
                                window.Vfc.$refs.messages.sendMessage('error', error.response.data.message);
                            })
                    }
                });
            },
        },

        watch: {
            tableData: {
                handler: function (val) {
                }
            },
            activeNotificationFilter(newVal) {
              window.V.$localStorage.set('BPZ_NOTIFICATION_FILTER', newVal)
              this.config.filter.like = newVal == 1 ? ['type:notification'] : []
              this.loadData()
            }
        },

        mounted(){
            if (!useDvFlagAccess("beepiz-notification-can:read")) {
                this.$router.push({ name: 'AccessDenied', params: { slug: 'sendNotifications'} })
            } else {
                if(!window.V.$localStorage.get('BPZ_NOTIFICATION_FILTER')) {
                  window.V.$localStorage.set('BPZ_NOTIFICATION_FILTER', 0)
                }
                this.activeNotificationFilter = window.V.$localStorage.get('BPZ_NOTIFICATION_FILTER')
                this.config.filter.like = this.activeNotificationFilter == 1 ? ['type:notification'] : []
                this.loadData();
            }
        }
    }
</script>

<style lang="scss">
  .notification-table {
    .fa-calendar {
      opacity: 0.5 !important;
    }
  }
</style>
